__turbopack_context__.v({
  "Streamdown": "InAppAgentMessage-module__VCISYG__Streamdown",
  "compact": "InAppAgentMessage-module__VCISYG__compact",
  "dark": "InAppAgentMessage-module__VCISYG__dark",
  "prose": "InAppAgentMessage-module__VCISYG__prose",
  "prose-sm": "InAppAgentMessage-module__VCISYG__prose-sm",
  "thinking-shimmer": "InAppAgentMessage-module__VCISYG__thinking-shimmer",
  "thinkingShimmer": "InAppAgentMessage-module__VCISYG__thinkingShimmer",
});
